module.exports = __webpack_public_path__ + "img/food3.cab4e97d.jpg";